import "./style.css";
import mypic from "../../../assets/aboutImage.JPG";
const AboutMe = () => {
  return (
    <div className="about-me-section">
      <h2>About Me</h2>
      <div className="about-me-section-inner-section">
        <div className="about-me-section-information-container">
          <p className="about-me-section-para-1">
            Hello! My name is Abhishek, and I’m a passionate developer from
            India with a strong interest in frontend and backend technologies,
            as well as AWS. I primarily focus on frontend development while also
            building backend functionalities and utilizing AWS services to
            deliver scalable and reliable cloud-based solutions.
          </p>
          <p className="about-me-section-para-2">
            Currently I'm working as a{" "}
            <span className="about-me-section-para-highlight">
              Frontend Developer at MobFountain Media.
              <br />{" "}
            </span>
            As my full-time role, I primarily develop dynamic, high-performance
            websites using modern frontend libraries and frameworks, while
            managing complex company data through CMS platforms to ensure
            scalability, reliability, and smooth content workflows.
          </p>
          <p className="about-me-section-para-3">
            As 2 years of experience, I consider myself at an early professional
            stage and a quick learner who actively explores new technologies,
            especially in cloud and modern web development. I regularly
            experiment with and implement new tools to understand their
            fundamentals and continuously strengthen my skill set.
          </p>

          <div className="about-me-section-skills">
            Here are a few technologies I've been working with recently:
            <div className="about-me-section-skills-list-wrapper">
              <div>
                <ul>
                  <li>JavaScript (ES6+)</li>
                  <li>React js</li>
                  <li>Next js</li>
                  <li>Express.js</li>
                </ul>
              </div>
              <div>
                <ul>
                  <li>Github Actions</li>
                  <li>Docker Basic</li>
                  <li>AWS Basic</li>
                  <li>CI/CD Basic</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="about-me-section-image-container">
          <img
            className="about-me-section-image-container-my-pic-image"
            src={mypic}
            alt=""
          />
        </div>
      </div>
    </div>
  );
};
export default AboutMe;
